import 'jquery';

// import 'bootstrap';
// import 'bootstrap/js/dist/util';
// import 'animate.css';
// import Wow from 'wow.js';
// new Wow().init();

// mainpage productivity fit text
  (function(root,factory){"use strict";if(typeof define==="function"&&define.amd){define([],factory)}else if(typeof exports==="object"){module.exports=factory()}else{root.textFit=factory()}})(typeof global==="object"?global:this,function(){"use strict";var defaultSettings={alignVert:false,alignHoriz:false,multiLine:false,detectMultiLine:true,minFontSize:6,maxFontSize:80,reProcess:true,widthOnly:false,alignVertWithFlexbox:false};return function textFit(els,options){if(!options)options={};var settings={};for(var key in defaultSettings){if(options.hasOwnProperty(key)){settings[key]=options[key]}else{settings[key]=defaultSettings[key]}}if(typeof els.toArray==="function"){els=els.toArray()}var elType=Object.prototype.toString.call(els);if(elType!=="[object Array]"&&elType!=="[object NodeList]"&&elType!=="[object HTMLCollection]"){els=[els]}for(var i=0;i<els.length;i++){processItem(els[i],settings)}};function processItem(el,settings){if(!isElement(el)||!settings.reProcess&&el.getAttribute("textFitted")){return false}if(!settings.reProcess){el.setAttribute("textFitted",1)}var innerSpan,originalHeight,originalHTML,originalWidth;var low,mid,high;originalHTML=el.innerHTML;originalWidth=innerWidth(el);originalHeight=innerHeight(el);if(!originalWidth||!settings.widthOnly&&!originalHeight){if(!settings.widthOnly)throw new Error("Set a static height and width on the target element "+el.outerHTML+" before using textFit!");else throw new Error("Set a static width on the target element "+el.outerHTML+" before using textFit!")}if(originalHTML.indexOf("textFitted")===-1){innerSpan=document.createElement("span");innerSpan.className="textFitted";innerSpan.style["display"]="inline-block";innerSpan.innerHTML=originalHTML;el.innerHTML="";el.appendChild(innerSpan)}else{innerSpan=el.querySelector("span.textFitted");if(hasClass(innerSpan,"textFitAlignVert")){innerSpan.className=innerSpan.className.replace("textFitAlignVert","");innerSpan.style["height"]="";el.className.replace("textFitAlignVertFlex","")}}if(settings.alignHoriz){el.style["text-align"]="center";innerSpan.style["text-align"]="center"}var multiLine=settings.multiLine;if(settings.detectMultiLine&&!multiLine&&innerSpan.scrollHeight>=parseInt(window.getComputedStyle(innerSpan)["font-size"],10)*2){multiLine=true}if(!multiLine){el.style["white-space"]="nowrap"}low=settings.minFontSize+1;high=settings.maxFontSize+1;while(low<=high){mid=parseInt((low+high)/2,10);innerSpan.style.fontSize=mid+"px";if(innerSpan.scrollWidth<=originalWidth&&(settings.widthOnly||innerSpan.scrollHeight<=originalHeight)){low=mid+1}else{high=mid-1}}innerSpan.style.fontSize=mid-1+"px";if(settings.alignVert){addStyleSheet();var height=innerSpan.scrollHeight;if(window.getComputedStyle(el)["position"]==="static"){el.style["position"]="relative"}if(!hasClass(innerSpan,"textFitAlignVert")){innerSpan.className=innerSpan.className+" textFitAlignVert"}innerSpan.style["height"]=height+"px";if(settings.alignVertWithFlexbox&&!hasClass(el,"textFitAlignVertFlex")){el.className=el.className+" textFitAlignVertFlex"}}}function innerHeight(el){var style=window.getComputedStyle(el,null);return el.clientHeight-parseInt(style.getPropertyValue("padding-top"),10)-parseInt(style.getPropertyValue("padding-bottom"),10)}function innerWidth(el){var style=window.getComputedStyle(el,null);return el.clientWidth-parseInt(style.getPropertyValue("padding-left"),10)-parseInt(style.getPropertyValue("padding-right"),10)}function isElement(o){return typeof HTMLElement==="object"?o instanceof HTMLElement:o&&typeof o==="object"&&o!==null&&o.nodeType===1&&typeof o.nodeName==="string"}function hasClass(element,cls){return(" "+element.className+" ").indexOf(" "+cls+" ")>-1}function addStyleSheet(){if(document.getElementById("textFitStyleSheet"))return;var style=[".textFitAlignVert{","position: absolute;","top: 0; right: 0; bottom: 0; left: 0;","margin: auto;","display: flex;","justify-content: center;","flex-direction: column;","}",".textFitAlignVertFlex{","display: flex;","}",".textFitAlignVertFlex .textFitAlignVert{","position: static;","}"].join("");var css=document.createElement("style");css.type="text/css";css.id="textFitStyleSheet";css.innerHTML=style;document.body.appendChild(css)}});

  if(jQuery("#productivity__bgtext").length) {
    // get first word
    document.getElementById('productivity__bgtext').innerHTML = jQuery(".productivity_section h2").text().split(" ")[0];
    var fittedText = document.getElementById('productivity__bgtext');
    textFit(fittedText, {widthOnly: true, maxFontSize: 300}) // eslint-disable-line
    $(window).resize(function(){
      textFit(fittedText, {widthOnly: true, maxFontSize: 300}) // eslint-disable-line
    });
  }
// eof mainpage productivity fix text 

// sticky header
  // When the user scrolls the page, execute myFunction 
  window.onscroll = function() {myFunction()};

  // Get the header
  var header = document.querySelector("header.header .container");

  // Get the offset position of the navbar
  var sticky = header.offsetTop;

  // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
  function myFunction() {
    if (window.pageYOffset >= sticky+500) {
      header.classList.add("container--sticky");
    } else {
      header.classList.remove("container--sticky");
    }
  }

// eof sticky header

// replace svg img to inline
  $(function() {
    $('img.svg').each(function() {
      var $img = $(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');
      $.get(imgURL, function(data) {
        var $svg = $(data).find('svg');
        if (typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
        }
        if (typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass + ' replaced-svg');
         }
         $svg = $svg.removeAttr('xmlns:a');
         $img.replaceWith($svg);
      }, 'xml');
    });
  });
// eof replace svg img to inline

// anchor scroll
  $(".js-scrollto").click(function(e){
    e.preventDefault();
    $('html, body').animate({ scrollTop: $($.attr(this, 'href')).offset().top-77}, 700);
  });

  $(".mobile_menu .js-scrollto").click(function(e){
    e.preventDefault();
    $(".menu-toggle").toggleClass("toggled");
    document.getElementById('nav-box').classList.toggle('active');
  });
// eof anchor scroll

// contact form buttons reset 
  var contactForm = $(".contact_us_section .wpcf7");
  contactForm.find(".btn_submit").on("click", function(){
    contactForm.find(".btn_submit").addClass("btn_submit--loading");
    setTimeout(function(){
      contactForm.find(".btn_submit").prop("disabled","true");
    },100);
  });
  contactForm.on('wpcf7:invalid', function(){
    contactForm.find(".btn_submit").prop("disabled","").removeClass("btn_submit--loading");
    $(".wpcf7-not-valid").focusin(function(){
      $(this).removeClass("wpcf7-not-valid");
    });
  });
  contactForm.on('wpcf7:mailsent', function(){
    jQuery(".wr_form").remove();
    // jQuery(".thank").slideDown(400);
    $(".contact_us_section").addClass("contact_us_section--thank");
    $(".contact_us_section").find(".cont").remove();
    
    // contactForm.find(".btn_submit").prop("disabled"," ").removeClass("btn_submit--loading");

  });
// eof contact form buttons reset 

// accordeon
  $(".accordeon__item-heading").click(function(){
    var item = $(this).parents(".accordeon__item");
    item.toggleClass("accordeon__item--expanded");
    item.find(".accordeon__item-wrapper").slideToggle();
  });
// eof accordeon

// pagination add arrow
  if($(".pagination").length) {
    if(!$(".pagination a.next").length) {
      $(".navigation").append('<a class="next next--disabled page-numbers" href="#"></a>');
    }
    if(!$(".pagination a.prev").length) {
      $(".navigation").prepend('<a class="prev next--disabled page-numbers" href="#"></a>');
    }
  }
// eof pagination add arrow


// WEBPACK FOOTER //
// ./resources/assets/scripts/main.js